const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

const beneficios = [
  {
    icon: "ri-building-line",
    title: "Direto da Fábrica",
    desc: "Sem intermediários. Você paga o preço justo com a qualidade de quem produz.",
    color: "bg-amber-50",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-tools-line",
    title: "Instalação Rápida e Limpa",
    desc: "Sem quebra-quebra, sem poeira, sem obra. Seu ambiente pronto em horas.",
    color: "bg-stone-50",
    iconColor: "text-stone-700",
  },
  {
    icon: "ri-temp-cold-line",
    title: "Conforto Térmico e Acústico",
    desc: "Tecnologia que reduz ruídos e mantém a temperatura ideal no seu espaço.",
    color: "bg-amber-50",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-home-4-line",
    title: "Ideal para Apartamentos",
    desc: "Perfeito para condomínios. Instalação sem impacto nas unidades vizinhas.",
    color: "bg-stone-50",
    iconColor: "text-stone-700",
  },
  {
    icon: "ri-leaf-line",
    title: "Visual Sofisticado",
    desc: "Acabamento tipo madeira nobre com toda a praticidade do vinílico moderno.",
    color: "bg-amber-50",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-shield-star-line",
    title: "Alta Durabilidade",
    desc: "Resistente a riscos, umidade e tráfego intenso. Beleza que dura anos.",
    color: "bg-stone-50",
    iconColor: "text-stone-700",
  },
];

export default function Beneficios() {
  return (
    <section id="beneficios" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Vantagens Exclusivas</span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Por que escolher a Vynora?
          </h2>
          <p className="text-stone-500 text-sm md:text-lg max-w-xl mx-auto">
            Qualidade premium, preço de fábrica e instalação sem complicação
          </p>
          <div className="w-12 h-0.5 bg-amber-600 mx-auto mt-5" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-16">
          {beneficios.map((b) => (
            <div
              key={b.title}
              className={`${b.color} rounded-xl md:rounded-2xl p-4 md:p-8 group hover:-translate-y-1 transition-all duration-300 border border-stone-100`}
            >
              <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center bg-white rounded-lg md:rounded-xl mb-3 md:mb-5">
                <i className={`${b.icon} text-lg md:text-2xl ${b.iconColor}`} />
              </div>
              <h3 className="text-stone-800 font-bold text-sm md:text-lg mb-1 md:mb-2 leading-snug">{b.title}</h3>
              <p className="text-stone-500 text-xs md:text-sm leading-relaxed hidden sm:block">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=beautiful%20modern%20apartment%20living%20room%20transformation%20with%20premium%20vinyl%20wood%20flooring%2C%20elegant%20furniture%2C%20warm%20lighting%2C%20sophisticated%20Brazilian%20interior%20design%2C%20ultra%20realistic%20photography&width=1400&height=400&seq=cta001&orientation=landscape"
            alt="Transforme seu ambiente"
            className="w-full h-44 sm:h-56 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-16">
            <p className="text-amber-400 text-xs font-bold tracking-widest uppercase mb-2">Pronto para transformar?</p>
            <h3 className="text-white text-lg md:text-4xl font-bold mb-4 max-w-lg" style={{ fontFamily: "'Playfair Display', serif" }}>
              Seu ambiente merece o melhor piso
            </h3>
            <a
              href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20quero%20falar%20com%20um%20especialista"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-xs md:text-sm px-5 md:px-8 py-2.5 md:py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-arrow-right-circle-line text-sm md:text-lg" />
              Fale com um especialista
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}